<template>
    <div id="app">
        <!-- 菜单导航 -->
        <Nav v-bind="{'type':'1','active':'1','isScrolledToTop':isScrolledToTop}" />
        <!-- banner轮播 -->
        <div class="site_banner">
            <img src="@/assets/index/index_banner.jpg" alt="">
        </div>
        <!-- <el-carousel height="25vw" class="banner" :interval="interval" trigger="click">
            <el-carousel-item>
                <img src="@/assets/index/banner.jpg" alt="" srcset="">
            </el-carousel-item>
            <el-carousel-item>
                <img src="@/assets/index/banner2.jpg" alt="" srcset="">
            </el-carousel-item>
            <el-carousel-item>
                <img src="@/assets/index/banner.jpg" alt="" srcset="">
            </el-carousel-item>
            <el-carousel-item>
                <img src="@/assets/index/banner2.jpg" alt="" srcset="">
            </el-carousel-item>
        </el-carousel> -->
    
        <!-- 新闻图文列表信息 -->
        <!-- <section class="index-news">
            <div class="index-news-img">
                <div>
                    <a href="./policy.html"><img src="@/assets/index/policy.jpg"></a>
                </div>
            </div>
            <NewsList v-bind="{'type':'1','list':newsData1,'link':'./news_details.html?active=2','listNum':4}"
                class="index-newsList">
                <template v-slot:title>
                    <div class="index-newsList-top">
                        <div class="index-newsList-title">
                            <span>政策法规</span>
                        </div>
                        <a href="./policy.html">更多></a>
                    </div>
                </template>
            </NewsList>
        </section> -->
        <!-- 新闻图文列表信息 -->
        <div class="index-title" style="margin-left: calc((100vw - 1204px) / 2);margin-top: 150px;">
            <img src="@/assets/index/index_icon4.png" alt="">
            <span>通知公告</span>
        </div>
        <section class="index-news" style="height: auto;padding:0;">
            <!-- <NewsList v-bind="{'type':'2','list':newsData2,'link':'./news_details.html?active=4','listNum':6}"
                class="index-newsList index-newsList2">
                <template v-slot:title>
                    <div class="index-newsList-top">
                        <div class="index-newsList-title">
                            <span>通知公告</span>
                        </div>
                        <a href="./notification.html">更多></a>
                    </div>
                </template>
            </NewsList> -->
            <div class="notice_list">
                <a class="notice_item" :href="'./news_details.html?active=4&id='+item.id"  v-for="(item,index) in newsData2" :key="index" v-if="index < 5">
                    <div class="notice_item_time">
                        <div class="notice_item_time_year">
                            {{item.modifyTime | datefilterYear}}
                        </div>
                        <div class="notice_item_time_month">
                            {{item.modifyTime | datefilterDay}}
                        </div>
                    </div>
                    <div class="notice_item_txt">
                        <!-- <div> -->
                            {{item.contentTitle}}
                        <!-- </div> -->
                    </div>
                </a>
                <a href="./notification.html" class="more-btn">查看更多</a>
            </div>
            <!-- 综试区业务功能区 -->
            <div class="index-newsList index-newsList3">
                <img src="@/assets/index/notice_bg.png" alt="">
            </div>
        </section>
    
        <section class="index-policy">
            <div class="index-title">
                <img src="@/assets/index/index_icon5.png" alt="">
                <span>政策法规</span>
            </div>
            <div class="policy_list">
                <a :href="'./news_details.html?active=2&id='+item.id" class="policy_item" v-for="(item,index) in newsData1" :key="index" v-if="index < 8">
                    <div class="policy_item_month">{{item.modifyTime | datefilterDay}}</div>
                    <div class="policy_item_year">{{item.modifyTime | datefilterYear}}</div>
                    <div class="policy_item_txt">{{item.contentTitle}}</div>
                </a>
            </div>
            <a href="./policy.html" class="more-btn">查看更多</a>
        </section>
    
    
        <!-- 行业新闻 -->
        <section class="index-showNews" style="padding-bottom: 46px;">
            <div class="index-title">
                <img src="@/assets/index/index_icon6.png" alt="">
                <span>行业新闻</span>
            </div>
            <div class="index-showNews-newCardList">
                <a v-for="(item,index) in newsData3" :key="index" :href="'./news_details.html?active=3&id='+item.id"
                    class="index-showNews-newCardLi" v-if="index < 3">
                    <div class="index-showNews-newCardLi-img">
                        <img :src="item.contentImg" alt="">
                    </div>
                    <div class="newsFirst">{{item.contentTitle}}</div>
                    <div class="newsLast">{{item.modifyTime | datefilter}}</div>
                </a>
            </div>
            <a href="./tradeNews.html" class="more-btn">查看更多</a>
        </section>
        <!-- 地区图片 -->
        <!-- <section class="index-pic">
            <img src="@/assets/index/map.png" alt="">
        </section> -->
        <!-- 综试区介绍-->
        <!-- <section class="index-news">
            <NewsList v-bind="{'type':'1','list':newsData156,'link':'./synopsis.html#/synopsis','listNum':1}"
                class="index-newsList" style="height:auto">
                <template v-slot:title>
                    <div class="index-newsList-top">
                        <div class="index-newsList-title" style="width: 140px;">
                            <span>综试区介绍</span>
                        </div>
                        <a href="./synopsis.html#/synopsis">更多></a>
                    </div>
                </template>
            </NewsList>
            <NewsList v-bind="{'type':'1','list':newsData157,'link':'./invite.html#/invite','listNum':1}"
                class="index-newsList" style="height:auto">
                
            </NewsList>
            <NewsList v-bind="{'type':'1','list':newsData158,'link':'./intro_details.html?active=8&getdata=158','listNum':2}"
                class="index-newsList" style="height:auto">
                
            </NewsList>
        </section> -->
    
        <section class="index-info">
            <div class="index-info-left">
                <div class="index-title">
                    <img src="@/assets/index/index_icon7.png" alt="">
                    <span>综试区介绍</span>
                </div>
                <div class="index-info-list">
                    <div class="index-info-item">
                        <div class="index-info-item-title">
                            <div class="index-info-item-point"></div>
                            <a :href="`./synopsis.html#/synopsis?id=${newsData156.length?newsData156[0].id:''}`">{{newsData156.length?newsData156[0].contentTitle:''}}</a>
                        </div>
                        <div class="index-info-item-content">
                            <div class="index-info-item-content-txt">{{newsData156.length?newsData156[0].contentDescription:''}}</div>
                            <a :href="`./synopsis.html#/synopsis?id=${newsData156.length?newsData156[0].id:''}`" class="index-info-item-content-btn">详情</a>
                        </div>
                    </div>
                    <div class="index-info-item">
                        <div class="index-info-item-title">
                            <div class="index-info-item-point"></div>
                            <a :href="`./synopsis.html#/invite?id=${newsData157.length?newsData157[0].id:''}`">{{newsData157.length?newsData157[0].contentTitle:''}}</a>
                        </div>
                        <div class="index-info-item-content">
                            <div class="index-info-item-content-txt">{{newsData157.length?newsData157[0].contentDescription:''}}</div>
                            <a :href="`./synopsis.html#/invite?id=${newsData157.length?newsData157[0].id:''}`" class="index-info-item-content-btn">详情</a>
                        </div>
                    </div>
                    <div class="index-info-item">
                        <div class="index-info-item-title">
                            <div class="index-info-item-point"></div>
                            <a :href="`./intro_details.html?active=8&getdata=158&id=${newsData158.length?newsData158[0].id:''}`">{{newsData158.length?newsData158[0].contentTitle:''}}</a>
                        </div>
                        <div class="index-info-item-content">
                            <div class="index-info-item-content-txt">{{newsData158.length?newsData158[0].contentDescription:''}}</div>
                            <a :href="`./intro_details.html?active=8&getdata=158&id=${newsData158.length?newsData158[0].id:''}`" class="index-info-item-content-btn">详情</a>
                        </div>
                    </div>
                </div>
                <a href="./synopsis.html#/synopsis" class="more-btn">查看更多</a>
            </div>
            <div class="index-info-right">
                <div class="index-title" style="margin-bottom: 60px;">
                    <img src="@/assets/index/index_icon8.png" alt="">
                    <span>通关工具</span>
                </div>
                <a href="clearance.html#/parameter" class="index-info-right-box">
                    <div class="index-info-right-box-icon">
                        <img src="@/assets/index/index_icon9.png" alt="">
                    </div>
                    <div class="index-info-right-box-txt">
                        通关数据查询
                    </div>
                </a>
                <a href="clearance.html#/tariff" class="index-info-right-box">
                    <div class="index-info-right-box-icon" style="background: #F19D0C;">
                        <img src="@/assets/index/index_icon10.png" alt="">
                    </div>
                    <div class="index-info-right-box-txt">
                        税则查询
                    </div>
                </a>
            </div>
        </section>
        <!-- 企业展厅 -->
        <!-- <section class="index-showCompany">
            <div class="index-showCompany-title">
                <h4>企业展厅</h4>
                <a href="./showCompany.html">更多></a>
            </div>
        
            <div class="index-showCompany-content">
                <a :href="'./showCompany.html?code='+item.code" v-for="(item,index) in CompanyList" :key="index"
                    class="index-showCompany-li">
                    <img :src="item.compamImg" alt="">
                </a>
            </div>
        </section> -->
    
        <!-- 功能块 -->
        <FunctionBlock ref="functionBlock" />
        <!-- 页脚 -->
        <Footer />
    </div>
</template>

<script>
import "./index.scss";
import Nav from "@/components/newsComponents/NavMenu/index.vue";
import NewsList from "@/components/newsComponents/newsList/index.vue";
import Footer from "@/components/newsComponents/footer/index.vue";
import FunctionBlock from "@/components/newsComponents/functionBlock/index.vue";
import { Carousel, CarouselItem, Message } from "element-ui";
export default {
    name: "App",
    components: {
        Nav,
        Footer,
        NewsList,
        FunctionBlock,
        [Carousel.name]: Carousel,
        [CarouselItem.name]: CarouselItem,
        [Message.name]: Message,
    },
    data() {
        return {
            islogin: window.sessionStorage.getItem("isLogin")
                ? window.sessionStorage.getItem("isLogin")
                : false,
            sfList: [
                {
                    img: require("@/assets/index/index_01.png"),
                    content: "我要看",
                },
                {
                    img: require("@/assets/index/index_02.png"),
                    content: "我要办",
                },
                {
                    img: require("@/assets/index/index_03.png"),
                    content: "我要查",
                },
                {
                    img: require("@/assets/index/index_04.png"),
                    content: "我要问",
                },
            ],
            CompanyList: [
                {
                    compamImg: require("@/assets/index/company_01.png"),
                    code: "1",
                },
                {
                    compamImg: require("@/assets/index/company_02.png"),
                    code: "10",
                },
                {
                    compamImg: require("@/assets/index/company_03.png"),
                    code: "2",
                },
                {
                    compamImg: require("@/assets/index/company_04.png"),
                    code: "3",
                },
                {
                    compamImg: require("@/assets/index/company_05.png"),
                    code: "4",
                },
                {
                    compamImg: require("@/assets/index/company_06.png"),
                    code: "5",
                },
                {
                    compamImg: require("@/assets/index/company_07.png"),
                    code: "6",
                },
                {
                    compamImg: require("@/assets/index/company_08.png"),
                    code: "9",
                },
                {
                    compamImg: require("@/assets/index/company_09.png"),
                    code: "7",
                },
                {
                    compamImg: require("@/assets/index/company_10.png"),
                    code: "8",
                },
            ],
            checkForm: {
                status: "2", //已发布
                contentCategoryId: "", //152-政策法规、153-行业新闻、154-通知公告
                companId: 0,
                indexFlag: "Y",
                pageNum: 1,
                pageSize: 10,
            },
            newsData1: [],
            newsData2: [],
            newsData3: [],

            newsData156: [],
            newsData157: [],
            newsData158: [],

            interval1: 3000,
            interval: 5500,
            serverList: [],
            isScrolledToTop: true
        };
    },
    filters:{
        datefilter: function (val) {
            var date = new Date(val);
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? "0" + m : m;
            var d = date.getDate();
            d = d < 10 ? "0" + d : d;
            return y + "-" + m + "-" + d;
        },
        datefilterYear:function(val){
            var date = new Date(val);  
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            return y ;
        },
        datefilterDay:function(val){
            var date = new Date(val);  
            var y = date.getFullYear();
            var m = date.getMonth() + 1;
            m = m < 10 ? ('0' + m) : m;
            var d = date.getDate();
            d = d < 10 ? ('0' + d) : d;
            return m + '-' + d ;
        }
    },
    created() {
        this.getData("152");
        this.getData("154");
        this.getData("153");

        this.getData("156");
        this.getData("157");
        this.getData("158");

        this.$api.visitLog({webServerType:0,pageName:'首页'})
    },
    mounted() {
        setTimeout(() => {
            if (window.sessionStorage.getItem("isLogin")) {
                this.getWebSystem();
            }
        }, 200);
        // 监听滚动事件
        window.addEventListener('scroll', this.handleScroll);
    },
    beforeUnmount() {
        // 移除滚动事件监听，防止内存泄漏
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        // 获取所有用户可进入系统
        async getWebSystem() {
            let res = await this.$api.queryAllWebServer({
                userId: JSON.parse(window.sessionStorage.getItem("officialWebsiteUserMsg"))
                    .webUserId,
            });
            if (res.resultCode == 200) {
                this.serverList = res.result;
            }
        },
        // 获取列表数据
        getData: function (id) {
            let postData = Object.assign({}, this.checkForm);
            if (id == "153") {
                postData.pageSize = 4;
            }
            if(id == "156"){
                postData.pageSize = 1;
            }
            if(id == "157"){
                postData.pageSize = 1;
            }
            if(id == "158"){
                postData.pageSize = 2;
            }
            postData.contentCategoryId = id;
            this.$api
                .queryContentList(postData)
                .then((res) => {
                    if (res.data.resultCode == 200) {
                        switch (id) {
                            case "152":
                                this.newsData1 = res.data.result;
                                console.log(this.newsData1);
                                break;
                            case "154":
                                this.newsData2 = res.data.result;
                                console.log(this.newsData2, 'newsData2');
                                break;
                            case "153":
                                this.newsData3 = res.data.result;
                                break;
                            case "156":
                                this.newsData156 = res.data.result;
                                console.log(this.newsData156, 11111111)
                                break;
                            case "157":
                                this.newsData157 = res.data.result;
                                console.log(this.newsData157)
                                break;
                            case "158":
                                this.newsData158 = res.data.result;
                                console.log(this.newsData158)
                                break;
                        }
                    } else {
                        this.$message.error({ title: res.data.resultDesc });
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        // 获取企业展厅
        // getcompany(){
        //   this.$api.getExhibitFirst({
        //     status: '2',
        //     firstPage: '0',
        //     pageNum: 1,
        //     pageSize: 10
        //   }).then(res=>{
        //     if(res.msg.indexOf('成功')!=-1){
        //       // let length = res.data.length;
        //       // console.log(res.data,length);
        //       // let arr = [];
        //       // for(var i=0;i<length;i+=5){
        //       //   arr.push(res.data.slice(i,i+5));
        //       // }
        //       // 赋值
        //       console.log(res.data);
        //       this.CompanyList = res.data;
        //     }else{
        //       this.$message.error({ title: res.msg });
        //     }
        //   }).catch(err=>{
        //     console.log(err);
        //   })
        // },
        toLink(type, webId) {
            let userType = JSON.parse(window.sessionStorage.getItem("officialWebsiteUserMsg"));
            let islogin = window.sessionStorage.getItem("isLogin")
                ? window.sessionStorage.getItem("isLogin")
                : false;
            let isprivate = false;
            if (userType) {
                if (userType.webUserType == "0") {
                    isprivate = true;
                }
            }
            switch (type) {
                case "1":
                    if (webId == '0') {
                        window.location.href = './synopsis.html#/synopsis'
                    } else if (webId == '1') {
                        window.location.href = './synopsis.html#/invite'
                    } else if (webId == '2') {
                        window.location.href = './synopsis.html#/support'
                    }
                    break;
                case "2":
                if (webId == '0') {
                        window.location.href = 'https://www.bjac.org.cn/'
                    } else {
                        // 匹配path
                        let path = this.dicFilter(webId, this.serverList);
                        if (!islogin) {
                            window.location.href =
                                this.$api.base +
                                "/gatewayWebsiteServer/login/casLogin";
                        }
                        // else if(isprivate){
                        //   this.$message({
                        //     message: '暂无权限',
                        //     type: 'warning'
                        //   });
                        // }
                        else {
                            // window.location.href = './myCentre.html#/putOnRecord'
                            // window.location.href = './putOnRecord.html#/putOnRecord'
                            if (path != "") {
                                window.location.href = path;
                            } else {
                                this.$message({
                                    message: "暂无权限",
                                    type: "warning",
                                });
                            }
                        }
                    }
                    break;
                case "3":
                    if (webId == '0') {
                        window.location.href = './dataQuery.html#/personal'
                    } else if (webId == '1') {
                        window.location.href = './dataQuery.html#/imported'
                    } else if (webId == '2') {
                        window.location.href = './dataQuery.html#/exit'
                    }
                    break;
                case "4":
                    window.location.href = "./clearance.html#/crossBorder";
                    break;
                case "5":
                    if (!islogin) {
                        window.location.href =
                            this.$api.base +
                            "/gatewayWebsiteServer/login/casLogin";
                    } else if (isprivate) {
                        this.$message({
                            message: "暂无权限",
                            type: "warning",
                        });
                    } else {
                        window.location.href =
                            "./myCentre.html#/enterpriseCommunication";
                    }
                    break;
                case "6":
                    if (!islogin) {
                        window.location.href =
                            this.$api.base +
                            "/gatewayWebsiteServer/login/casLogin";
                    } else {
                        window.location.href =
                            "./myCentre.html#/complaintAdvise";
                    }
                    break;
                case "7":
                    this.$refs["functionBlock"].openService();
                    break;
            }
        },
        // 匹配path
        dicFilter(val, list) {
            let back = "";
            list.map((v, i) => {
                if (v.serverId == val) {
                    back = v.interfacePath;
                }
            });
            return back;
        },
        handleScroll() {
            // 当滚动距离大于20px时，改变导航栏样式
            this.isScrolledToTop = window.scrollY <= 20;
        }
    },
};
</script>